import { useTranslation } from "react-i18next";

import { NavItemType } from "../mcn-react-ui/Navbar/Navbar";

const useNavItems = () => {
  const { t } = useTranslation();

  const navItems: NavItemType[] = [
    { href: "#services", text: t("nav.services") },
    { href: "#about", text: t("nav.studio") },
    { href: "#portfolio", text: t("nav.projects") },
    { href: "#contact", text: t("nav.contact"), hilight: true },
  ];

  return navItems;
};

export default useNavItems;
